import { render, staticRenderFns } from "./AutoPostTip.vue?vue&type=template&id=5859f4a3&scoped=true&"
import script from "./AutoPostTip.vue?vue&type=script&lang=js&"
export * from "./AutoPostTip.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./AutoPostTip.vue?vue&type=style&index=1&id=5859f4a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859f4a3",
  null
  
)

export default component.exports